import * as React from "react";
import type { SVGProps } from "react";
const SvgStatsDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={13}
    fill="none"
    viewBox="0 0 10 13" {...props}
  >
    <path
      fill="#258695"
      d="M6.944 0 10 3.25v9.105a.67.67 0 0 1-.178.456.6.6 0 0 1-.429.189H.607a.6.6 0 0 1-.428-.19.67.67 0 0 1-.179-.455V.645C0 .289.272 0 .607 0zm-2.5 3.25v6.5h1.223v-6.5zm2.445 2.6v3.9H8.11v-3.9zM2 7.15v2.6h1.222v-2.6z"
    />
  </svg>
);
export default SvgStatsDark;
